import { Controller } from 'stimulus';

export default class extends Controller {
  selectSwitch(event) {
    const input = this.element.querySelector('input[name="' + event.target.dataset.field + '"]');
    input.disabled = false;
    input.value = event.target.dataset.value;
    document.querySelectorAll('a[data-field="' + event.target.dataset.field + '"]').forEach(element => {
      element.classList.remove('is-info');
    });
    event.target.classList.add('is-info');
  }
}